<template>
  <div id="amap-container">
    <div v-show="!haveLocationInfo" class="haveLocationInfo">
      <div class="haveLocationP">{{ $t('allDeviceDetail.NoLocationInfo') }}</div>
    </div>
    <div v-show="isShowGDMap" id="custom-amap" :style="{height:height}" />
    <div v-show="!isShowGDMap" id="googleMap" :style="{height:height, width: '100%'}">
      <div class="googleMap" style="width: 100%;">
        <gmap-map
          :center="centers"
          :map-type-control="false"
          :options="{styles: googleMapStyles}"
          :style="{height:height}"
          :zoom="8"
          style="width: 100%;"
        >
          <gmap-marker
            v-for="(m, index) in markers"
            :key="index"
            :clickable="true"
            :draggable="false"
            :icon="m.icon"
            :position="m.position"
            :title="m.title"
            @click="centers=m.position"
          />
          <!-- @click="centers=m.position" -->
        </gmap-map>
      </div>
    </div>
    <div v-if="isShowGDMap&&$route.path=='/allDevices/allDeviceIndex'" class="el-icon-full-screen fullScreen" @click="fullScreen" />
    <div v-show="isShowMapFloat" id="mapFloatBox">
      <p class="mapFloatBoxTitle">{{ $t('AllDevices.GraphicDescription') }}</p>
      <p>
        <img :src="positionIcon[0].imgUrl" alt>
        {{ $t('AllDevices.abnormal') }}
      </p>
      <p>
        <img :src="positionIcon[1].imgUrl" alt>
        {{ $t('AllDevices.normal') }}
      </p>
    </div>
    <div v-show="isShowMarkerInfo" id="markerInfo">
      <i class="el-icon-close" @click="isShowMarkerInfo=false" />
      <p class="deviceName" @click="gotoDetail">{{ markerInfo.deviceName }}</p>
      <p class="deviceSn">{{ markerInfo.deviceSn }}({{ markerInfo.type }})</p>
      <p class="">{{ markerInfo.lastLocationTimeZh }}</p>
    </div>
  </div>
</template>

<script>
var oldHeight
import mapIconRed from '@/assets/icon/map_icon_red.png'
import mapIconBlue from '@/assets/icon/map_icon_blue.png'
import mapIconGreen from '@/assets/icon/map_icon_green.png'
import { loadTiandiJs } from '@/components/tianMap/asyncLoadJs'
import { tianMapLngLat } from '@/utils/transformLatLng'
import { getDateAndHour } from '@/utils/updateTime.js'
import { mapState } from 'vuex'
// import coordtransform from '@/utils/coordtransform'
// const AMap = window.AMap
// 定义一些常量
var x_PI = (3.14159265358979324 * 3000.0) / 180.0
var PI = 3.1415926535897932384626
var a = 6378245.0
var ee = 0.00669342162296594323
export default {
  name: 'AMap',
  props: {
    defaultValue: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
      // default: '340px'
    },
    isShowGDMap: {
      type: Boolean,
      default: null
    },
    isShowMapFloat: {
      type: Boolean,
      default: false
    },
    haveLocationInfo: {
      type: Boolean,
      default: true
    },
    centerMarkerInfo: {
      type: Object,
      default: () => {}
    }
  },
  
  data() {
    return {
      aMap: null,
      googleMap: null,
      thisPosition: null,
      positionIcon: [
        { imgUrl: require('@/assets/icon/map_icon_red.png') },
        { imgUrl: require('@/assets/icon/map_icon_green.png') },
        { imgUrl: require('@/assets/icon/map_icon_blue.png') }
      ],
      fullscreen: false,
      isFlag: 0,

      centers: { lat: 0, lng: 0 },
      // centers: { },
      markers: [],
      place: null,
      mapTypeControl: false, // 去掉卫星地图
      googleMapStyles: [
        {
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5'
            }
          ]
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161'
            }
          ]
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#f5f5f5'
            }
          ]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#bdbdbd'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575'
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5'
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dadada'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161'
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5'
            }
          ]
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#c9c9c9'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        }
      ],
      tianMapLoadFinished: false,
      timer: null,
      yellowIcon: null,
      greenIcon: null,
      amapMarkers: [],
      locationArray: [],
      markerInfo: {
        deviceName: null,
        deviceSn: null,
        type: null,
        deviceType: null,
        lastLocationTimeZh: null
      },
      isShowMarkerInfo: false,
      oldMcuid: null,
      num: 0
    }
  },
  computed: {
    ...mapState(['map', 'isAdmin'])
  },
  watch: {
    centerMarkerInfo(obj) { // 点击列表上的定位点时，弹窗中的设备信息改变--天地图
      console.log('this.centerMarkerInfo', obj)
      this.isShowMarkerInfo = false
      if (!obj.mcuId) return
      this.centers = {lng: obj.lon, lat: obj.lat}

      this.setIcon(obj.mcuId, this.greenIcon, 'greenIcon')
      if (this.oldMcuid && this.oldMcuid != obj.mcuId) this.setIcon(this.oldMcuid, this.yellowIcon, 'yellowIcon')

      this.setMarkerInfo(obj)
      this.oldMcuid = obj.mcuId
      if (obj.mcuId) this.isShowMarkerInfo = true
      this.aMap.centerAndZoom(tianMapLngLat(obj.lon, obj.lat))
    }
  },
  mounted() {
    console.log('11')
    // 初始化地图页面
    oldHeight = this.height
    this.$nextTick(() => {
      setTimeout(() => {
        this.loadTiandi()// 天地图
      })
    })
    const that = this
    window.onresize = function() {
      // console.log('that.isFlag', that.isFlag)
      // console.log(that.checkFull())
      if (that.isFlag > 0) {
      // 通过isFlag来判断是否需要触发事件，不加会导致进入页面后窗口大小改变也会触发事件
        if (!that.checkFull()) {
        // 退出全屏后要执行的动作
          that.$emit('fullScreen', oldHeight)
          that.fullScreen()
          that.isFlag = 0
        }
      }
    }
  },
  beforeDestroy() {
    if (this.aMap) {
      // this.aMap.destroy()
    }
    // this.destroy()
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  created() {
    // 每次进入界面时，先清除之前的所有定时器，然后启动新的定时器
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    setTimer() {
      // 定时器
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (!this.tianMapLoadFinished) this.loadTiandi()
        }, 6000)
      }
    },
    setMakers(locationArray) { // 高德或谷歌地图上添加maker
      console.log('地图定位点：', locationArray)
      var that = this
      this.locationArray = locationArray
      if (!this.isShowGDMap) {
        // 谷歌地图
        this.markers = []
        // var iconBase = 'https://maps.google.com/mapfiles/kml/paddle/'
        locationArray.forEach(v => {
          var lat = v.lat
          var lng = v.lon
          var iType = v.ltype
          var deviceName = v.deviceName
          var lastLocationTime = v.lastLocationTime
          var date = new Date(lastLocationTime)
          var dateTimeStr = date.toLocaleString()
          var content = []
          content.push(deviceName)
          content.push(dateTimeStr)
          var ggIcon
          if (v.status === 1) {
            ggIcon = mapIconRed
          } else if (v.status === 2) {
            ggIcon = mapIconBlue
          } else {
            ggIcon = mapIconGreen
          }
          if (lat && lng) {
            var type = ''
            var googlePosition = { lat: lat, lng: lng }
            // debugger
            switch (iType) {
              case 1:
                type = 'GNSS'

                var position84 = that.gcj02towgs84(
                  Number.parseFloat(lng),
                  Number.parseFloat(lat)
                )
                googlePosition = { lat: position84[1], lng: position84[0] }
                break
              case 0: type = 'LBS1'; break
              case 2: type = 'LBS2'; break
              case 3: type = 'LBS3'; break
              default:
                position84 = that.gcj02towgs84(
                  Number.parseFloat(lng),
                  Number.parseFloat(lat)
                )

                googlePosition = { lat: position84[1], lng: position84[0] }

                break
            }
            content.push(type)

            var googleMrker = {
              // icon: iconBase + ggIcon,
              icon: {
                url: ggIcon
                // scaledSize: new google.maps.Size(40, 40)
              },
              title: content.join('\r\n'),

              position: googlePosition
            }
            this.markers.push(googleMrker)
          }
        })
        if (this.markers[0]) this.centers = this.markers[0].position
      } else {
        const that = this
        console.log('locationArray', locationArray)
        if (!this.aMap) {
          if (!locationArray.length) return
          if (locationArray.length && this.num <= 10) {
            setTimeout(() => {
              this.setMakers(locationArray)
              this.num++
            }, 3000)
          }
          return
        }
        this.aMap.clearOverLays()
        this.isShowMarkerInfo = false
        if (locationArray.length == 0) {
          this.$emit('getCenterMcuid', null)
          return
        }
        this.amapMarkers = []
        this.aMap.centerAndZoom(tianMapLngLat(locationArray[0].lon, locationArray[0].lat))
        this.setMarkerInfo(locationArray[0])

        for (let i = 0; i < locationArray.length; i++) {
          if (locationArray[i].lon && locationArray[i].lat) {
            const locationStatus = locationArray[i].locationStatus

            if (!locationStatus && !this.isAdmin) { // 定位关闭 并且 非管理员
              continue
            }
            const element = [locationArray[i].lon, locationArray[i].lat]
            const marker = new T.Marker(tianMapLngLat(element[0], element[1]), { icon: this.yellowIcon })
            marker.list_index = i
            marker.mcuId = locationArray[i].mcuId
            this.amapMarkers.push(marker)
            this.aMap.addOverLay(marker)
            marker.on('click', (e) => {
              this.clickMarker(e.target.mcuId)
            })
          }
        }
        this.setIcon(locationArray[0].mcuId, this.greenIcon, 'greenIcon')
        this.$emit('getCenterMcuid', locationArray[0].mcuId)
        this.oldMcuid = locationArray[0].mcuId
        console.log('this.amapMarkers', this.amapMarkers)
      }
    },
    clickMarker(mcuId) { // 点击描点--天地图
      if (this.$route.path != '/allDevices/allDeviceIndex') return
      this.isShowMarkerInfo = true
      this.locationArray.forEach(v => {
        if (mcuId == v.mcuId) {
          this.setMarkerInfo(v)
          this.setIcon(mcuId, this.greenIcon, 'greenIcon')
          this.$emit('getCenterMcuid', mcuId)

          if (this.oldMcuid && this.oldMcuid != mcuId) this.setIcon(this.oldMcuid, this.yellowIcon, 'yellowIcon')
          this.oldMcuid = mcuId
        }
      })
    },
    setMarkerInfo(v) { // 设置弹窗中的信息--天地图
      for (var attr in v) this.markerInfo[attr] = v[attr]
      if (v.lastLocationTime) this.markerInfo.lastLocationTimeZh = getDateAndHour(v.lastLocationTime, 'noSecond')
      switch (v.ltype) {
        case 1:this.markerInfo.type = 'GNSS'; break
        case 0: this.markerInfo.type = 'LBS1'; break
        case 2: this.markerInfo.type = 'LBS2'; break
        case 3: this.markerInfo.type = 'LBS3'; break
      }
      console.log('this.markerInfo', this.markerInfo)
    },
    setActiveMarker(data, oldData) { // 设置中心标记
      console.log('设置中心标记：', data)

      const isDouble = this.$storage.get('is_double')
      const offset = isDouble ? 0.04 : 0.02

      let index = 0

      if (this.map == 'ggMap') {
        this.markers.forEach((element, i) => {
          element.setIcon({
            url: './static/icons/yellow.png',
            scaledSize: new google.maps.Size(20, 20)
          })
          if (element.id == this.locationId) {
            index = i
          }
        })
        console.log(this.markers[index])
        this.markers[index].setIcon('./static/icons/green.png')

        this.aMap.setCenter(new google.maps.LatLng(data[1], data[0] - offset))
        this.aMap.setZoom(this.aMap.getZoom())
      } else {
        this.list.forEach((item, i) => {
          if (item.id == this.locationId) {
            index = i
          }
        })
        this.lays = this.aMap.getOverlays()
        // console.log('lays',this.lays)
        console.log('oldData', oldData)
        // console.log('data',data)
        if (oldData && oldData.length > 2 && oldData[2] != 0) {
          // this.removeMarker(oldData[2])
          // this.addMarker(oldData[0],oldData[1],oldData[2],this.yellowIcon)
          this.setIcon(oldData[2], this.yellowIcon, 'yellowIcon')
        }
        // this.removeMarker(data[2])
        // this.addMarker(data[0],data[1],data[2],this.greenIcon)
        this.setIcon(data[2], this.greenIcon, 'greenIcon')
        // this.aMap.centerAndZoom(new T.LngLat(data[0] - offset, data[1]), this.aMap.getZoom());
        this.aMap.centerAndZoom(tianMapLngLat(data[0], data[1]), this.aMap.getZoom())
      }
    },
    setIcon(mcuId, icon, val) { // 设置定位点Icon--天地图
      this.amapMarkers.forEach((v, i) => {
        if (mcuId && mcuId == v.mcuId) {
          v.setIcon(icon)
          v.Fr.classList.add(val)
        }
      })
    },
    fullScreen() {
      this.isFlag++
      // const element = document.documentElement
      const element = document.getElementById('amap-container')
      var fullScreenHeight = window.screen.height + 'px'
      console.log('fullScreenHeight', fullScreenHeight)
      console.log('oldHeight', oldHeight, this.fullscreen)
      if (this.fullscreen) {
        // 退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
        this.$emit('fullScreen', oldHeight)
        this.isFlag = 0
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen()
        }
        this.$emit('fullScreen', fullScreenHeight)
      }
      this.fullscreen = !this.fullscreen
    },
    checkFull() {
      // var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
      var isFull = document.mozFullScreen || document.fullScreen || // 谷歌浏览器及Webkit内核浏览器
        document.webkitIsFullScreen || document.webkitRequestFullScreen || document.mozRequestFullScreen || document.msFullscreenEnabled
      // console.log('isFull', isFull)
      if (isFull === undefined) isFull = false
      return isFull
    },
    loadTiandi() { // 加载--天地图
      const that = this
      loadTiandiJs().then(res => {
        console.log('天地图加载成功11')
        clearInterval(this.timer)
        that.tianMapLoadFinished = true
        this.initTianMap()
      }).catch(() => {
        console.log('天地图加载失败12')
        that.tianMapLoadFinished = false
      })
    },
    initTianMap() { // 初始化--天地图
      this.aMap = ''
      // 初始化地图对象
      this.aMap = new T.Map('custom-amap')
      // 设置显示地图的中心点和级别
      this.aMap.centerAndZoom(tianMapLngLat(114.068842, 22.655542), 10)
      // console.log('theme',this.theme)
      this.yellowIcon = new T.Icon({
        iconUrl: require('@/assets/icon/yellow.png'), // "http://api.tianditu.gov.cn/img/map/markerA.png",
        iconSize: new T.Point(20, 20),
        iconAnchor: new T.Point(10, 25)
      })
      this.greenIcon = new T.Icon({
        iconUrl: require('@/assets/icon/green.png'), // "http://api.tianditu.gov.cn/img/map/markerA.png",
        iconSize: new T.Point(30, 30),
        iconAnchor: new T.Point(10, 25)
      })
      // this.initData()
    },
    gotoDetail() { // 去详情页--天地图
      console.log(this.markerInfo)
      var routeData = null
      if (this.markerInfo.deviceType.indexOf('e') > -1) {
        routeData = this.$router.resolve({
          path: '/allDevices/allDeviceLithiumDetail',
          query: {
            mcuId: this.markerInfo.mcuId,
            deviceType: 'e',
            sn: this.markerInfo.deviceSn,
            id: this.markerInfo.id
          }
        })
      } else if (this.markerInfo.deviceType.indexOf('c') > -1) {
        routeData = this.$router.resolve({
          path: '/allDevices/trionicDetail',
          query: {
            mcuId: this.markerInfo.mcuId,
            deviceType: 'c',
            sn: this.markerInfo.deviceSn,
            id: this.markerInfo.id,
            deviceTypeT: this.markerInfo.deviceName
          }
        })
      } else if (this.markerInfo.deviceType.indexOf('i') > -1) {
        routeData = this.$router.resolve({
          path: '/allDevices/allDeviceEveBmsDetail',
          query: {
            mcuId: this.markerInfo.mcuId,
            deviceType: 'i',
            sn: this.markerInfo.deviceSn,
            id: this.markerInfo.id
          }
        })
      } else if (this.markerInfo.deviceType.indexOf('j') > -1) {
        routeData = this.$router.resolve({
          path: '/allDevices/allDeviceEveF477Detail',
          query: {
            mcuId: this.markerInfo.mcuId,
            deviceType: 'j',
            sn: this.markerInfo.deviceSn,
            id: this.markerInfo.id
          }
        })
      } else if (this.markerInfo.deviceType.indexOf('a') > -1) {
        routeData = this.$router.resolve({
          path: '/allDevices/allDeviceDetail',
          query: {
            mcuId: this.markerInfo.mcuId,
            deviceType: this.markerInfo.deviceType,
            sn: this.markerInfo.deviceSn,
            id: this.markerInfo.id
          }
        })
      }
      window.open(routeData.href, '_self')
    },
    gcj02towgs84(lng, lat) {
      var lat = +lat
      var lng = +lng
      if (this.out_of_china(lng, lat)) {
        return [lng, lat]
      } else {
        var dlat = this.transformlat(lng - 105.0, lat - 35.0)
        var dlng = this.transformlng(lng - 105.0, lat - 35.0)
        var radlat = (lat / 180.0) * PI
        var magic = Math.sin(radlat)
        magic = 1 - ee * magic * magic
        var sqrtmagic = Math.sqrt(magic)
        dlat = (dlat * 180.0) / (((a * (1 - ee)) / (magic * sqrtmagic)) * PI)
        dlng = (dlng * 180.0) / ((a / sqrtmagic) * Math.cos(radlat) * PI)
        var mglat = lat + dlat
        var mglng = lng + dlng
        return [lng * 2 - mglng, lat * 2 - mglat]
      }
    },

    transformlat(lng, lat) {
      var lat = +lat
      var lng = +lng
      var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng))
      ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0
      ret += ((20.0 * Math.sin(lat * PI) + 40.0 * Math.sin((lat / 3.0) * PI)) * 2.0) / 3.0
      ret += ((160.0 * Math.sin((lat / 12.0) * PI) + 320 * Math.sin((lat * PI) / 30.0)) * 2.0) / 3.0
      return ret
    },
    transformlng(lng, lat) {
      var lat = +lat
      var lng = +lng
      var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
      ret += ((20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0) / 3.0
      ret += ((20.0 * Math.sin(lng * PI) + 40.0 * Math.sin((lng / 3.0) * PI)) * 2.0) / 3.0
      ret += ((150.0 * Math.sin((lng / 12.0) * PI) + 300.0 * Math.sin((lng / 30.0) * PI)) * 2.0) / 3.0
      return ret
    },
    out_of_china(lng, lat) {
      var lat = +lat
      var lng = +lng
      // 纬度3.86~53.55,经度73.66~135.05
      return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55)
    }
  }
}
</script>
<style lang="scss" scoped>
#amap-container {
  width: 100%;
  position: relative;
  .haveLocationInfo {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.5);
    .haveLocationP {
      background: #fff;
      padding: 20px 40px;
      color: black;
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 100;
      margin-top: -28px;
      margin-left: -82px;
    }
  }
  .el-input__clear {
    line-height: 34px;
  }
  // #custom-amap {
  //   width: 100%;
  //   border: 1px solid #ccc;
  // }
  .input-with {
    z-index: 1;
    width: 580px;
  }
  .address {
    color: #373737;
  }
}
.amap-sug-result {
  z-index: 99999;
}
#mapFloatBox {
  position: absolute;
  width: 200px;
  bottom: 02px;
  left: 02px;
  background: rgba(0, 0, 0, 0.3);
  color: white;
  padding: 10px 20px;
}
#mapFloatBox p {
  font-size: 14px;
  line-height: 30px;
  display: flex;
  align-items: center;
}
#mapFloatBox p.mapFloatBoxTitle {
  font-size: 16px;
  margin-bottom: 5px;
}
#mapFloatBox img {
  height: 22px;
  margin-right: 10px;
}
.fullScreen {
  position: absolute;
  bottom: 10px!important;
  top: auto!important;
  right: 10px;
  font-size: 25px;
  cursor: pointer;
  z-index: 999;
}
#markerInfo{
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  background: #ffffffbd;
  padding: 10px 20px;
  border-radius: 0 0 0 10px;
  font-size: 14px;
  .deviceName{
    font-weight: bold;
    color: #1890ff;
    cursor: pointer;
    margin-top: 15px;
  }
  .deviceSn{
    margin:8px 0 5px;
  }
  .el-icon-close{
    position: absolute;
    top: 2px;
    right: 3px;
    padding: 5px;
    cursor: pointer;
  }
}

</style>
